<template>
    <div class="tnc-wrapper">
        <h2><span style="font-size: 16pt">លក្ខខណ្ឌ</span></h2>
        <h4>
            <strong><span style="font-size: 12pt">ច្បាប់ទូទៅ</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">គេហទំព័ររបស់យើងត្រូវបានកំណត់ចំពោះតែបុគ្គលដែលមានអាយុស្របច្បាប់
                        ដូចដែលបានកំណត់នៅក្នុងដែនសមត្ថកិច្ចដែលបុគ្គលនោះរស់នៅ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">គេហទំព័ររបស់យើងមិនទទួលខុសត្រូវចំពោះច្បាប់ជាតិ ច្បាប់សហព័ន្ធ
                        ឬច្បាប់អន្តរជាតិណាមួយដែលត្រូវបានរំលោភបំពានដោយអ្នកប្រើប្រាស់ណាមួយដែលប្រើប្រាស់គេហទំព័ររបស់យើងឡើយ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">អ្នកប្រើប្រាស់ទទួលខុសត្រូវចំពោះសកម្មភាពផ្ទាល់ខ្លួនរបស់ពួកគេ
                        ហើយត្រូវបានចងភ្ជាប់ដោយច្បាប់របស់ប្រទេសរបស់ពួកគេ ដែលរួមមានច្បាប់រដ្ឋ ឬបញ្ហាផ្លូវច្បាប់។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ភ្នាក់ងារទាំងអស់ទទួលខុសត្រូវចំពោះគណនីរបស់សមាជិករៀងៗខ្លួន
                        ហើយត្រូវគោរពការភ្នាល់ដែលបានបញ្ជាក់ទាំងអស់ដែលដាក់ដោយពួកគេ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ភ្នាក់ងារមិនមែនជាដៃគូរបស់គេហទំព័ររបស់យើងទេ។
                        ដូច្នេះគេហទំព័ររបស់យើងមិនទទួលខុសត្រូវចំពោះភាពមិនស៊ីសង្វាក់គ្នា ឬជម្លោះណាមួយរវាងអ្នកលេង
                        និងភ្នាក់ងារឡើយ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span
                        style="font-size: 10.5pt">វាជាការទទួលខុសត្រូវរបស់អ្នកប្រើប្រាស់ក្នុងការការពារលេខសម្គាល់អ្នកប្រើប្រាស់
                        និងពាក្យសម្ងាត់របស់គាត់/នាងពីការប្រើប្រាស់ដោយគ្មានការអនុញ្ញាត។ ប្រសិនបើលេខសម្គាល់អ្នកប្រើប្រាស់
                        និងពាក្យសម្ងាត់របស់អ្នកប្រើប្រាស់ត្រូវបានគេលួច ឬត្រូវបានគេលួច
                        វាជាការទទួលខុសត្រូវរបស់អ្នកប្រើប្រាស់ក្នុងការទាក់ទងភ្នាក់ងាររបស់គាត់/នាងជាបន្ទាន់។
                        បន្ទាប់មកភ្នាក់ងារនឹងផ្លាស់ប្តូរលេខសម្គាល់អ្នកប្រើប្រាស់
                        និងពាក្យសម្ងាត់របស់អ្នកប្រើប្រាស់សម្រាប់គាត់។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ក្នុងករណីមានលេខសម្គាល់អ្នកប្រើប្រាស់ និងពាក្យសម្ងាត់ត្រូវបានគេលួច
                        អ្នកប្រើប្រាស់ត្រូវទទួលខុសត្រូវចំពោះគណនីរៀងៗខ្លួន
                        ហើយនឹងគោរពតាមការភ្នាល់ដែលបានបញ្ជាក់ទាំងអស់ដែលបានដាក់ជូន។</span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">ច្បាប់លេងហ្គេម</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p><span style="font-size: 10.5pt">លទ្ធផលហ្គេមដែលសម្រេចដោយគេហទំព័ររបស់យើងនឹងជាការសម្រេចចុងក្រោយ
                        និងមានผลผูกพัน។</span></p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ក្នុងករណីមានជម្លោះទាំងអស់ ទាំងក្រុមគ្រប់គ្រងគេហទំព័ររបស់យើង
                        និងអ្នកលេងត្រូវតែយល់ព្រមថា
                        មូលដ្ឋានទិន្នន័យកំណត់ហេតុប្រតិបត្តិការគេហទំព័ររបស់យើងនឹងបម្រើជាអាជ្ញាកណ្តាលចុងក្រោយក្នុងជម្លោះ។
                        ជម្លោះទាំងអស់ត្រូវតែដាក់ជូនក្នុងរយៈពេលថ្ងៃដែលលទ្ធផលនៃការប្រកួតត្រូវបានកំណត់។
                        គ្មានការទាមទារណាមួយនឹងត្រូវបានគោរពបន្ទាប់ពីថ្ងៃប្រកួតនោះទេ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span
                        style="font-size: 10.5pt">អ្នកលេងទទួលខុសត្រូវទាំងស្រុងចំពោះការផ្ទៀងផ្ទាត់ភាពត្រឹមត្រូវនៃប្រតិបត្តិការគណនីរបស់ពួកគេទាំងអស់។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">សូមប្រាកដថាអ្នកបានពិនិត្យមើលការភ្នាល់របស់អ្នកសម្រាប់កំហុសឆ្គង
                        ឬការខកខានណាមួយមុនពេលដាក់ស្នើវាតាមកុំព្យូទ័រ។ នៅពេលដែលការភ្នាល់ត្រូវបានទទួលយកតាមកុំព្យូទ័រហើយ
                        វាមិនអាចផ្លាស់ប្តូរ ឬលុបចោលបានទេ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">យើងខ្ញុំរក្សាសិទ្ធិក្នុងការបង្កក
                        ឬលុបចោលគណនីរបស់អតិថិជនណាមួយដែលត្រូវបានរកឃើញថាបានរំលោភលើលក្ខខណ្ឌទាំងនេះ
                        ចូលរួមក្នុងសកម្មភាពក្លែងបន្លំ ឈ្លានពាន វាយប្រហារ ក្លែងបន្លំ បំផ្លាញច្បាប់ស្តង់ដារ
                        ឬពាក់ព័ន្ធនឹងការភ្នាល់រួមគ្នា ដោយសមតុល្យគណនីលទ្ធផលទាំងអស់នឹងត្រូវបានបង្កក
                        និងរឹបអូសដោយមិនចាំបាច់ជូនដំណឹងជាមុន។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">យើងខ្ញុំរក្សាសិទ្ធិក្នុងការលុបចោល ឬលុបចោលការភ្នាល់
                        ឬសំបុត្រណាមួយដែលត្រូវបានរកឃើញថាជាប់ទាក់ទងនឹងការភ្នាល់រួមគ្នា ការភ្នាល់សម្របសម្រួល ការឃុបឃិត
                        ការក្លែងបន្លំ ការរំលោភបំពានប្រព័ន្ធ ការកេងប្រវ័ញ្ចកំហុសបច្ចេកទេស ហាងឆេងមិនត្រឹមត្រូវ
                        ឬការប៉ុនប៉ងផ្សេងទៀតដើម្បីទទួលបានអត្ថប្រយោជន៍មិនយុត្តិធម៌។
                        ការឈ្នះដែលពាក់ព័ន្ធណាមួយអាចត្រូវបានបញ្ច្រាស់ ហើយគណនីដែលពាក់ព័ន្ធអាចត្រូវបានផ្អាក ឬបញ្ចប់។</span>
                </p>
            </li>
        </ol>
        <h4>
            <strong><span style="font-size: 12pt">ដែនកំណត់ និងបំណុល</span></strong>
        </h4>
        <ol>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ដោយមិនប៉ះពាល់ដល់ភាពទូទៅនៃអ្វីដែលបានរៀបរាប់ខាងលើ
                        គេហទំព័ររបស់យើងនឹងមិនទទួលខុសត្រូវចំពោះបុគ្គលណាម្នាក់ក្នុងករណីមានការបំផ្លិចបំផ្លាញ
                        ហេតុការណ៍មិនអាចគ្រប់គ្រងបាន និង/ឬចំពោះព្រឹត្តិការណ៍នៃការបរាជ័យ ឬការខូចខាត
                        ឬការបំផ្លិចបំផ្លាញប្រព័ន្ធកុំព្យូទ័រកណ្តាល ឬកំណត់ត្រា ឬផ្នែកណាមួយនៃគេហទំព័ររបស់យើង ឬការពន្យារពេល
                        ការខាតបង់ កំហុស ការលុបចោល ឬបញ្ហាផ្សេងទៀតដែលបណ្តាលមកពីការបរាជ័យនៃប្រព័ន្ធទូរគមនាគមន៍
                        ឬប្រព័ន្ធបញ្ជូនទិន្នន័យណាមួយ
                        ឬការពន្យារពេលណាមួយដែលបណ្តាលឱ្យមិនទទួលបានការចូលរួមណាមួយសម្រាប់ការប្រណាំងជាក់លាក់ណាមួយ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span
                        style="font-size: 10.5pt">គេហទំព័ររបស់យើងនឹងមិនទទួលខុសត្រូវចំពោះការខាតបង់ណាមួយដែលជាលទ្ធផលនៃអំពើរបស់ព្រះ
                        ក្នុងការផ្ទុះឡើងនៃអរិភាព កុបកម្ម ភាពចលាចលស៊ីវិល អំពើភេរវកម្ម អំពើរបស់រដ្ឋាភិបាល ឬអាជ្ញាធរ
                        (រួមទាំងការបដិសេធ ឬការដកហូតអាជ្ញាប័ណ្ណ ឬការយល់ព្រមណាមួយ) អគ្គីភ័យ ទឹកជំនន់ ចោរកម្ម
                        ការខូចខាតដោយចេតនា កូដកម្ម ការបិទទ្វារ និងសកម្មភាពឧស្សាហកម្មគ្រប់ប្រភេទ។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ក្នុងករណីមានការតភ្ជាប់បណ្តាញ ការទំនាក់ទំនង ប្រព័ន្ធ ឬកំហុសរបស់មនុស្ស
                        ដែលបណ្តាលឱ្យមានបញ្ហាទាក់ទងនឹងការភ្នាល់ ដូចជាការភ្នាល់ទ្វេត្រូវបានទទួលយក
                        ការភ្នាល់មិនអាចបញ្ជាក់បាន ដាក់ភ្នាល់បន្ទាប់ពីហ្គេមចាប់ផ្តើម។ល។
                        យើងរក្សាសិទ្ធិក្នុងករណីមានកំហុសបែបនេះ ក្នុងការដោះស្រាយវាតាមករណីនីមួយៗ
                        និងចាត់វិធានការផ្សេងទៀតដើម្បីកែកំហុសបែបនេះ។ យើងនឹងមិនទទួលខុសត្រូវចំពោះអ្នក
                        ឬចំពោះភាគីទីបីណាមួយទាក់ទងនឹងកំហុសបែបនេះទេ។ ប្រសិនបើអ្នកបានជួបប្រទះកំហុសបែបនេះ
                        ហើយបន្តភ្នាល់ដោយមិនរាយការណ៍ទៅអ្នកក្រោមបង្គាប់របស់អ្នក អ្នកនឹងត្រូវទទួលខុសត្រូវ
                        និងគោរពលទ្ធផលឈ្នះ/ចាញ់ទាំងអស់ ប្រសិនបើកំហុសកើតឡើងម្តងទៀត។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ច្បាប់ និងបទប្បញ្ញត្តិទាំងនេះបង្កើតបានជាកិច្ចព្រមព្រៀង
                        និងការយោគយល់គ្នាទាំងមូលរវាងភាគីនានា។</span>
                </p>
            </li>
            <li style="list-style-type: decimal; font-size: 10.5pt">
                <p>
                    <span style="font-size: 10.5pt">ប្រសិនបើមានភាពខុសគ្នាណាមួយរវាងច្បាប់
                        និងបទប្បញ្ញត្តិទាំងនេះជាភាសាអង់គ្លេស និងច្បាប់ជាភាសាផ្សេងទៀត
                        ភាសាអង់គ្លេសនឹងជំនួសច្បាប់ជាភាសាផ្សេងទៀត ហើយត្រូវបានចាត់ទុកថាត្រឹមត្រូវ និងមានសុពលភាព។</span>
                </p>
            </li>
        </ol>
        <BurgerMenu v-if="isMobile" />
    </div>
</template>
<script>
    import BurgerMenu from '@/components/burger-menu.vue';
    import { isMobile } from 'mobile-device-detect';
    export default {
        components: {
            BurgerMenu,
        },
        data: () => {
            return {
                isMobile,
            };
        },
    };
</script>
<style lang="scss" scoped>
    .tnc-wrapper {
        padding: 16px 24px;
        box-sizing: border-box;
        height: calc(100% - 56px);
        overflow-y: auto;
    }

    strong,
    h2,
    h4 {
        font-weight: 600;
    }
</style>
